import { render } from "./PhoneView.vue?vue&type=template&id=2f5403a2&scoped=true"
import script from "./PhoneView.vue?vue&type=script&lang=js"
export * from "./PhoneView.vue?vue&type=script&lang=js"

import "./PhoneView.vue?vue&type=style&index=0&id=2f5403a2&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5403a2"]])

export default __exports__